const MISSING_VALUE_PATTERN = /not\s+(provided|recorded)/i;

export function hasDisplayValue(value) {
  if (value === undefined || value === null) return false;
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length > 0 && !MISSING_VALUE_PATTERN.test(trimmed);
  }
  return true;
}

export function displayValue(value) {
  return hasDisplayValue(value) ? value : null;
}

export function firstDisplayValue(...values) {
  return values.find(hasDisplayValue) ?? null;
}

export function joinDisplayValues(...values) {
  return values
    .filter(hasDisplayValue)
    .map((value) => String(value).trim())
    .join(" · ");
}
